// Compatibility shim (session data core D6): `sanitizeError` moved to
// `@heidi/runtime/logger` — it belongs to the logger's PHI contract and
// domain packages need it door-importable. Kept so the existing importers
// keep compiling until the Z-series codemod re-points them.
export { sanitizeError } from '@heidi/runtime/logger';
